import { fromMarkdown } from "mdast-util-from-markdown";
import { directiveFromMarkdown } from "mdast-util-directive";
import { gfmTableFromMarkdown } from "mdast-util-gfm-table";
import { directive } from "micromark-extension-directive";
import { gfmTable } from "micromark-extension-gfm-table";

type Options = NonNullable<Parameters<typeof fromMarkdown>[1]>;
export type Root = ReturnType<typeof fromMarkdown>;

/**
 * How the answer's Markdown is read: one configuration, for the engine and for everything that has
 * to agree with it about which lines are what (the one-line directive reader asks which lines are
 * code). Constructs that let later text change how earlier text was read are switched off.
 */
const OPTIONS: Options = {
  extensions: [
    {
      disable: {
        null: ["setextUnderline", "codeIndented", "htmlFlow", "htmlText", "definition", "autolink"],
      },
    },
    directive(),
    gfmTable(),
  ],
  mdastExtensions: [directiveFromMarkdown(), gfmTableFromMarkdown()],
};

export const tree = (source: string): Root => fromMarkdown(source, OPTIONS);
